import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useState } from 'react';

type InputWithErrorProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  type?: string;
  placeholder?: string;
};

export const InputWithError = ({
  label,
  name,
  value,
  onChange,
  error,
  type = 'text',
  placeholder = '',
}: InputWithErrorProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPasswordField = type === 'password';

  return (
    <div className="mb-2 relative">
      <label htmlFor={name} className="block text-md font-medium text-gray-700 mb-1">
        {label}
      </label>
      <input
        id={name}
        name={name}
        type={isPasswordField && showPassword ? 'text' : type}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className={`w-full px-2 py-1 border rounded-md focus:outline-none ${
          error ? 'border-red-500' : 'focus:ring-2 focus:ring-sky-500'
        }`}
      />
      {isPasswordField && (
        <span
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-9 cursor-pointer text-gray-500"
        >
          {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        </span>
      )}
      {error && <p className="text-md text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export const LoadingSpinner = () => {
    return (
        <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            ></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
            ></path>
        </svg>
    );
};
